export default __webpack_public_path__ + "static/media/core drum_1.1e189dbd.wav";